/**
 * PaymentTypeIcon Component
 *
 * Shared icon for payment type (bank, credit card, e-wallet).
 */

import { Landmark, CreditCard, Wallet } from "lucide-react";
import type { HistoricalTransaction } from "@/services/paymentService";
import { getPaymentTypeLogo } from "../utils/transactionUtils";

const iconMap: Record<string, typeof Landmark> = {
  bank: Landmark,
  bca: Landmark,
  mandiri: Landmark,
  cimb: Landmark,
  bni: Landmark,
  bri: Landmark,
  "credit-card": CreditCard,
  wallet: Wallet,
  gopay: Wallet,
  ovo: Wallet,
  dana: Wallet,
};

export function PaymentTypeIcon({ transaction }: { transaction: HistoricalTransaction }) {
  const logo = getPaymentTypeLogo(transaction);
  const Icon = iconMap[logo] ?? Wallet;

  return (
    <div className="text-muted-foreground">
      <Icon className="h-4 w-4" />
    </div>
  );
}
